import { get } from 'lodash';
import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import type { PTPFormField } from './utils';
import type { PTPPath } from './ptp-link-type';
import { FormResetContext } from 'src/pages/pmp/utils';
import ScanLossConfigGroup from 'src/pages/shared/ScanLossConfigGroup';

type Props = PTPFormField<any> & {
  endName: string;
  path: PTPPath;
  setModified: React.Dispatch<React.SetStateAction<boolean>>;
};

function ScanLoss(props: Props) {
  const { getValues } = useFormContext();
  const resetValue = useContext(FormResetContext);
  const { endName, path, setModified } = props;
  const pathIndex = props.pathIndex ?? 0;
  const pathPrefix = `${endName}.`;
  const calculateAttrPath = `${endName}.radios.${pathIndex}.antennas.0.config.user_calculate_scan_loss`;
  const frequencyMhz = getValues(
    `${endName}.radios.${pathIndex}.frequency.frequency_mhz`
  );

  return (
    <ScanLossConfigGroup
      pathPrefix={pathPrefix}
      pathIndex={pathIndex}
      frequencyMhz={frequencyMhz}
      calculateDefaultValue={get(path, calculateAttrPath)}
      setModified={setModified}
      formResetValue={resetValue}
    />
  );
}

export default ScanLoss;
